import React from 'react';
export const CTA = () => {
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-326">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1523438885200-e635ba2c371e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')] opacity-5 bg-fixed" data-id="element-327"></div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-328">
        <div className="max-w-4xl mx-auto text-center" data-id="element-329">
          <span className="inline-block px-4 py-1 bg-limestone-200 text-limestone-700 rounded-full text-sm font-medium mb-4" data-id="element-330">
            JOIN TODAY
          </span>
          <h2 className="text-5xl font-serif font-bold mb-6 text-gray-800 tracking-tight" data-id="element-331">
            Ready to Transform Your Wedding Planning Business?
          </h2>
          <p className="text-xl text-gray-600 mb-10" data-id="element-332">
            Join the Elite Planners Association today and start enjoying
            exclusive benefits, higher profits, and a supportive community of
            top professionals.
          </p>
          <a href="#masterclass-curriculum" className="inline-block bg-limestone-700 hover:bg-limestone-800 text-white font-bold py-4 px-12 rounded-lg text-xl transition transform hover:scale-105 shadow-lg mb-8" data-id="element-333">
            Join Our Masterclasses
          </a>
          <p className="mt-10 text-gray-500 text-sm" data-id="element-334">
            Have questions?{' '}
            <a href="#masterclass-curriculum" className="text-limestone-700 hover:text-limestone-800 font-medium" data-id="element-335">
              Learn more about our masterclasses
            </a>
          </p>
        </div>
      </div>
    </section>;
};